import React from 'react'
import MdPlace from 'react-icons/lib/md/place'
import { connect } from 'react-redux'
import { string } from 'prop-types'

const AddressPlaceHolder = ({ theme }) => (
  <div className="input-placeholder">
    <MdPlace color={theme} />
    Search signs
  </div>
)

AddressPlaceHolder.propTypes = {
  theme: string.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  theme: spi.theme,
})

export default connect(mapStateToProps)(AddressPlaceHolder)



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/AddressPlaceHolder.jsx